/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import {ActionType, createAction} from 'typesafe-actions';
import {NotificationEntry} from './model';

export const notificationAdded = createAction('NOTIFICATION_ADDED')<{ notification: NotificationEntry, autoClose: boolean }>();

export const notificationHidden = createAction('NOTIFICATION_HIDDEN')<{ identifier: string }>();

export const notificationRemoved = createAction('NOTIFICATION_REMOVED')<{ identifier: string }>();

export const notificationActionButtonClicked = createAction('NOTIFICATION_ACTION_BUTTON_CLICKED')<{ identifier: string }>();

export type ActionTypes =
	ActionType<typeof notificationAdded> |
	ActionType<typeof notificationHidden> |
	ActionType<typeof notificationRemoved> |
	ActionType<typeof notificationActionButtonClicked>;
